const LANDING_PAGE_ADMIN_EMAILS = [
  'atxbrosent@gmail.com',
  'omairr.mortaza@gmail.com',
];

const normalizeEmail = email => String(email || '').trim().toLowerCase();

export const isHardcodedAdminEmail = email => {
  const normalized = normalizeEmail(email);
  return Boolean(normalized && LANDING_PAGE_ADMIN_EMAILS.includes(normalized));
};

export const canAccessAdminDashboard = (email, currentUser) => {
  if (isHardcodedAdminEmail(email)) return true;
  const publicData = currentUser?.attributes?.profile?.publicData || {};
  if (publicData?.isOwner === true || publicData?.isAdmin === true) return true;
  const protectedData = currentUser?.attributes?.profile?.protectedData || {};
  const roles = protectedData?.roles || publicData?.roles;
  if (Array.isArray(roles) && (roles.includes('owner') || roles.includes('admin'))) {
    return true;
  }
  return false;
};

export const canAccessLandingPageSettings = email =>
  canAccessAdminDashboard(email);
